import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');
    try {
      const response = await fetch('http://localhost:5000/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (data.success) {
        setStatus('Message Sent Successfully!');
        setFormData({ name: '', email: '', message: '' });
        // Clear success message after 3 seconds
        setTimeout(() => setStatus(null), 3000);
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus('Failed to send message. Is the backend running?');
    }
  };

  return (
    <section id="contact">
      <div className="section-header">
        <h2 className="section-title">Get In Touch</h2>
        <p className="section-subtitle">Let's discuss how we can transform your business</p>
      </div>
      <div className="contact-container">
        <div className="contact-form-glass fade-in">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Full Name</label>
              <input 
                type="text" 
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required 
                placeholder="Your Name"
              />
            </div>
            <div className="form-group">
              <label>Email Address</label>
              <input 
                type="email" 
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                required 
                placeholder="email@example.com"
              />
            </div>
            <div className="form-group">
              <label>Message</label>
              <textarea 
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
                required
                placeholder="Tell us about your project..."
              ></textarea>
            </div>
            <button type="submit" className="glass-btn glass-btn-primary">
                <span>Send Message</span> →
            </button>
            {status && (
                <p style={{
                    marginTop: '1rem', 
                    color: status.includes('Failed') ? '#ff5f57' : '#4ade80',
                    fontWeight: 'bold'
                }}>
                    {status}
                </p>
            )}
          </form>
        </div>
        
        {/* Contact Info Side */}
        <div className="contact-info-glass fade-in">
            <div className="contact-item-glass">
                <div className="contact-icon-glass">📧</div>
                <div>
                    <h4>Email Us</h4>
                    <p>contact@zentaksolutions.com</p>
                </div>
            </div>
            <div className="contact-item-glass">
                <div className="contact-icon-glass">📞</div>
                <div>
                    <h4>Call Us</h4>
                    <p>+94 70 128 5090</p>
                </div>
            </div>
            <div className="contact-item-glass">
                <div className="contact-icon-glass">📍</div>
                <div>
                    <h4>Visit Us</h4>
                    <p>Auckland, New Zealand</p>
                </div>
            </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;